/* eslint-disable jsx-a11y/alt-text */
// components
import { Container } from '@/components/Grid/Container';

// styles
import {
  SolutionsWrapper,
  Title,
  SubTitle,
  StyledButton,
  Image,
} from './CTASection.styles';

export function CTASection() {
  return (
    <SolutionsWrapper>
      <Image
        bg={{
          xxlarge: 'images/warehouse/ctasection/cta-section-xxlg@2x.jpg',
          large: 'images/warehouse/ctasection/cta-section-xxlg@2x.jpg',
          medium: 'images/warehouse/ctasection/cta-section-xxlg@2x.jpg',
          small: 'images/warehouse/ctasection/cta-section-xxlg@2x.jpg',
        }}
      />
      <Container>
        <Title>What is the ROI of Dock Scheduling?</Title>
        <SubTitle>
          Digital dock scheduling offers warehouses both hard and soft savings.
          <br />
          Understand how you can save on both sides.
        </SubTitle>
        <StyledButton
          href="https://lp.opendock.com/fast-roi-ebook-0"
          target="_blank"
          rel="noopener noreferrer"
        >
          Download Now
        </StyledButton>
      </Container>
    </SolutionsWrapper>
  );
}
